export default __webpack_public_path__ + "assets/images/ring.gif?5f209f6e";